import React from 'react';

interface ReporterArgs {
  formId: string;
  formName: string;
  errors: { [key: string]: any } | null;
}

type reporterType = (args: ReporterArgs) => void;

interface ResolverArguments {
  formId: string;
  formName: string;
  reporter: reporterType;
}

interface ValidationErrors {
  [key: string]: {
    type: 'validation';
    message: string;
  };
}

export const useSingleFormValidationResolver = (
  validationSchema: any,
  { formId, formName, reporter }: ResolverArguments
) => {
  return React.useCallback(
    async (data: unknown) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });

        if (typeof reporter === 'function') {
          reporter({ formId, formName, errors: null });
        }

        return { values, errors: {} };
      } catch (error: any) {
        const errors = error.inner.reduce(
          (all: ValidationErrors, err: any) => ({
            ...all,
            [err.path]: {
              type: err.type ?? 'validation',
              message: err.message,
            },
          }),
          {}
        );

        if (typeof reporter === 'function') {
          reporter({ formId, formName, errors });
        }

        return {
          values: {},
          errors,
        };
      }
    },
    // eslint-disable-next-line
    [validationSchema]
  );
};
